import { http } from '../../config/axios'

export default function getRegistroDownload(id:string) :Promise<Blob>{
    return http.get('/api/registro/imprimir/' + id, {
        responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
        return blobFile
    })
    .catch((error) => {
        console.error('Erro ao getRegistroDownload')
        return new Blob()
    })
}